import React, { useState, useEffect, useRef } from "react";
import { Input } from "./input";

export function AirlineAutocomplete({ placeholder, value, onChange, options = [], className }) {
    const [query, setQuery] = useState(value || "");
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        setQuery(value || "");
    }, [value]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredOptions = query 
        ? options.filter((item) => {
            const airlineName = item.base_data_json?.airline || item.title || "";
            return airlineName.toLowerCase().includes(query.toLowerCase());
          })
        : options;

    const handleSearch = (searchTerm) => {
        setQuery(searchTerm);
        onChange(searchTerm, null); // Fallback: user free text
        setIsOpen(true);
    };

    const handleSelect = (item) => {
        const text = item.base_data_json?.airline || item.title || "";
        setQuery(text);
        onChange(text, item);
        setIsOpen(false);
    };

    return (
        <div ref={wrapperRef} className={`relative ${className || ""}`}>
            <Input
                placeholder={placeholder}
                value={query}
                onChange={(e) => handleSearch(e.target.value)}
                onFocus={() => { if (filteredOptions.length > 0) setIsOpen(true); }}
            />
            {isOpen && filteredOptions.length > 0 && (
                <div className="absolute z-50 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-y-auto">
                    {filteredOptions.map((item) => (
                        <div
                            key={item.id}
                            className="p-2 text-sm hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                            onClick={() => handleSelect(item)}
                        >
                            {item.base_data_json?.airline_logo && (
                                <img src={item.base_data_json.airline_logo} alt="logo" className="w-6 h-6 object-contain" />
                            )}
                            <span>{item.base_data_json?.airline || item.title}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
